import { useEffect, useState } from "react";

const INITIAL_STATE = {
  isOpen: false,
  title: "",
  subtitle: "",
  data: [],
  selectedDataKey: "",
  isLoading: false
};

const useHistogramModal = () => {
  const [histogramState, setHistogramState] = useState(INITIAL_STATE);

  useEffect(() => {
    document.body.style.overflow = histogramState.isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [histogramState.isOpen]);

  const openHistogram = (config) => setHistogramState({ ...INITIAL_STATE, isOpen: true, ...config });

  const updateHistogram = (config) => setHistogramState((prev) => ({ ...prev, ...config }));

  const closeHistogram = () => setHistogramState((prev) => ({ ...prev, isOpen: false }));

  return { histogramState, openHistogram, updateHistogram, closeHistogram };
};

export default useHistogramModal;
